<template>
  <div class="mobile-page">
    <div class="mobile-page-content mobile-no-navbar p-4">
      <div class="mobile-login-view">
        <div class="text-center">
          <p class="font-weight-bold my-2">Synergy Software Glass Platform</p>
          <p class="my-2"><small class="mobile-login-small">Please login to access the Glass Administration</small></p>
        </div>
        <FormGroup v-bind:form="loginForm">
          <div class="row m-b">
            <div class="col-lg-12">
              <FormInputText type="email" placeholder="Email" v-model="email" field="email" />
            </div>
          </div>
          <div class="row m-b">
            <div class="col-lg-12">
              <FormInputText
                type="password"
                placeholder="Password"
                v-model="password"
                field="password"
              />
            </div>
          </div>
          <div class="row m-b">
            <div class="col-lg-12">
              <FormCheckbox v-model="rememberMe" /> Remember Me
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <FormButton
                type="submit"
                class="btn btn-success block full-width m-b"
                data-style="expand-left"
                @click="onLoginSubmit"
                :loading="submitting"
                >Login</FormButton>
            </div>
          </div>
        </FormGroup>
        <p class="m-t text-center">
          <small class="mobile-login-small" v-html="`${appCopyrightInfo} - ${appVersion}`"></small>
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.mobile-login-view {
  padding: 25px;
  font-size: 1.4rem;
}
.mobile-login-view .form-control,
.mobile-login-view .btn {
  font-size: 1.5rem;
}
.mobile-login-small {
  font-size: 0.9rem;
}
.mobile-login-remember-me {
  font-size: 14px;
}
</style>

<script>
import form from "@/mixins/form";

export default {
  name: 'MobileLogin',
  mixins: [form],
  components: {},
  data: () => {
    return {
      email: '',
      password: '',
      rememberMe: false,
      loginForm: {},
      submitting: false
    };
  },
  mounted() {
    this.$data.email = this.$localStorage.get('login.email', '')
    this.$data.rememberMe = this.parseBoolean(this.$localStorage.get('login.rememberMe', false))
  },
  methods: {
    onLoginSubmit() {
      this.$data.loginForm = this.clearFormResponse()
      this.submitting = true

      this.$api.post("/users/authenticate", {
          email: this.email,
          password: this.password
        })
        .then(response => {

          if(this.rememberMe)
            this.$localStorage.set('login.email', this.email)
          else
            this.$localStorage.remove('login.email')
          this.$localStorage.set('login.rememberMe', this.rememberMe)

          this.$authService.setAuthToken(response.data.token, true);
          this.$socketService.connect()
          this.$router.push("/");
        })
        .catch(err => {
          // Process errors
          this.$data.loginForm = this.processFormResponse(err);
        })
        .finally(() => {
          this.submitting = false
        })
    }
  },
  computed: {
    appCopyrightInfo() {
      return this.$store.state.system.appCopyrightInfo
    },
    appVersion() {
      return this.$store.state.system.appVersion
    }
  }
}
</script>
